import {
  MdSpinner,
  TdlOverlay
} from "@torre-labs/material";
import Vue from "vue";

import SkeletonsMixin from "@/mixins/SkeletonsMixin";

export default Vue.extend({
  components: {
    TdlOverlay,
    MdSpinner
  },
  mixins: [SkeletonsMixin],
  mounted() {
    this.$nextTick(this.skeletonsMixin_removeSkeleton);
  }
});
